export default {
      id: "e-nach-registeration-usage",
      viewBox: "0 0 60 32",
      url: __webpack_public_path__ + "sprite.svg#e-nach-registeration",
      toString: function () {
        return this.url;
      }
    }